<div class="rewards-wallet-redeemed-list">
  <ng-container
    fgbDataSource
    [dataSource]="redeemedItems"
    [pageSize]="pageSize"
    [page]="pageNumber"
    (paginationChange)="pageLength = $event.pages.length"
  >
    <ng-template let-items let-loaded="loaded">
      <ng-container *ngIf="loaded; else loading">
        <div class="row">
          <ng-container *ngFor="let item of items">
            <div class="col-12">
              <div class="loyalty-item-container-redeemed">
                <fgbcl-rewards-wallet-redeemed-list-item
                  [item]="item"
                  routerLink="{{ getItemDetailUrl(item) }}"
                ></fgbcl-rewards-wallet-redeemed-list-item>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="pagination-container d-flex justify-content-center mt-3" *ngIf="pageLength > 1">
          <ngb-pagination
            [(page)]="pageNumber"
            [pageSize]="pageSize"
            [collectionSize]="redeemedItems.length"
            [maxSize]="7"
            size="sm"
          ></ngb-pagination>
        </div>
      </ng-container>
      <ng-template #loading>
        <div class="loading-container">
          <fgbcl-loading></fgbcl-loading>
        </div>
      </ng-template>
    </ng-template>
  </ng-container>
</div>
